<template>
  <InfoCard :title="title">
    <div class="artifacts scrollbar">
      <template v-if="artifacts && artifacts.length > 0">
        <DownloadModelCard
          v-for="(artifact, i) in artifacts"
          :key="i"
          :title="artifact.name"
          :modelType="artifact.modelType"
          class="download-model-card"
          :class="`${artifact.name}-btn`"
          @click="handleDownloadModel(artifact)"
        />
      </template>
      <template v-else>
        No model files
      </template>
    </div>
  </InfoCard>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue';
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import DownloadModelCard from '@/components/TrainerComponent/TrainerExperimentAndSessions/DownloadModelCard.vue';
import InfoCard from '@/components/InfoCard.vue';

const props = defineProps({
  sessionId: {
    type: [Number, String],
    required: true,
  },
  title: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['artifacts-loaded']);

const artifacts = ref([]);

async function getArtifacts(sessionId) {
  if (!sessionId) {
    artifacts.value = [];
    return;
  }

  try {
    const dataConnect = new DatastoreConnect();
    const resp = await dataConnect.getTrainingSessionArtifacts({
      training_session_id: parseInt(sessionId),
    });

    if (resp.error !== undefined) {
      throw Error(resp.error.message);
    }

    artifacts.value = resp.result || [];
  } catch (error) {
    console.error('Error fetching artifacts:', error);
    artifacts.value = [];
  }

  emit('artifacts-loaded', artifacts.value);
}

function handleDownloadModel(model) {
  const url = `/download_model?training_session_id=${props.sessionId}&file=${encodeURIComponent(model.name)}`;

  const a = document.createElement('a');
  a.href = url;
  a.setAttribute('download', '');
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

watch(() => props.sessionId, (newVal) => {
  if (newVal) {
    getArtifacts(newVal);
  }
});

onMounted(() => {
  if (props.sessionId) {
    getArtifacts(props.sessionId);
  }
});
</script>

<style scoped>
.artifacts {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
  overflow-y: auto;
  min-height: 0;
  padding: 4px;
}
</style>
